export class AgeRatingGuideModal {
    constructor() {
        this.container = null;
    }

    open() {
        this.container = document.createElement('div');
        this.container.className = 'fixed inset-0 z-[10000] flex items-center justify-center isolate';
        this.container.innerHTML = `
            <div class="backdrop absolute inset-0 bg-black/80 backdrop-blur-sm opacity-0 transition-opacity duration-300"></div>
            <div class="modal-box relative bg-zinc-900 border border-zinc-700 w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden opacity-0 scale-95 transition-all duration-300 transform">
                
                <!-- Header -->
                <div class="h-14 flex items-center justify-between px-6 border-b border-zinc-800 bg-zinc-950">
                    <h2 class="text-base font-bold text-white flex items-center gap-2">
                        <span class="material-symbols-outlined text-purple-500">book_online</span>
                        ${window.locale.t('rating_guide.title')}
                    </h2>
                    <button class="btn-close text-zinc-500 hover:text-white transition-colors">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                </div>

                <!-- Content -->
                <div class="p-6 space-y-6 overflow-y-auto max-h-[70vh]">
                    
                    <!-- 1. All -->
                    <div class="flex gap-4">
                        <div class="flex-shrink-0 w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center text-white font-black text-xs shadow-lg shadow-green-900/20">All</div>
                        <div>
                            <h3 class="text-white font-bold mb-1">${window.locale.t('rating_guide.all_title')}</h3>
                            <p class="text-zinc-400 text-xs leading-relaxed">
                                ${window.locale.t('rating_guide.all_desc')}
                            </p>
                        </div>
                    </div>

                    <!-- 2. 12+ -->
                    <div class="flex gap-4">
                        <div class="flex-shrink-0 w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center text-white font-black text-lg shadow-lg shadow-blue-900/20">12</div>
                        <div>
                            <h3 class="text-white font-bold mb-1">${window.locale.t('rating_guide.title_12')}</h3>
                            <p class="text-zinc-400 text-xs leading-relaxed">
                                ${window.locale.t('rating_guide.desc_12')}
                            </p>
                        </div>
                    </div>

                    <!-- 3. 15+ -->
                    <div class="flex gap-4">
                        <div class="flex-shrink-0 w-12 h-12 bg-amber-500 rounded-xl flex items-center justify-center text-white font-black text-lg shadow-lg shadow-amber-900/20">15</div>
                        <div>
                            <h3 class="text-white font-bold mb-1">${window.locale.t('rating_guide.title_15')}</h3>
                            <p class="text-zinc-400 text-xs leading-relaxed">
                                ${window.locale.t('rating_guide.desc_15')}
                            </p>
                        </div>
                    </div>

                    <!-- 4. 19+ -->
                    <div class="flex gap-4">
                        <div class="flex-shrink-0 w-12 h-12 bg-red-600 rounded-xl flex items-center justify-center text-white font-black text-lg shadow-lg shadow-red-900/20">19</div>
                        <div>
                            <h3 class="text-white font-bold mb-1">${window.locale.t('rating_guide.title_19')}</h3>
                            <p class="text-zinc-400 text-xs leading-relaxed">
                                ${window.locale.t('rating_guide.desc_19')}
                            </p>
                        </div>
                    </div>

                    <div class="bg-zinc-800/50 rounded-xl p-4 border border-zinc-700 mt-4 text-center text-xs text-zinc-500">
                        ${window.locale.t('rating_guide.disclaimer')}
                    </div>

                </div>

                <!-- Footer -->
                <div class="p-4 border-t border-zinc-800 bg-zinc-950 flex justify-end">
                    <button class="btn-close-main w-full py-3 bg-zinc-800 hover:bg-zinc-700 text-white rounded-xl font-bold text-sm transition-colors">
                        ${window.locale.t('rating_guide.confirm')}
                    </button>
                </div>
            </div>
        `;

        document.body.appendChild(this.container);

        // Bind
        const close = () => {
            const backdrop = this.container.querySelector('.backdrop');
            const box = this.container.querySelector('.modal-box');
            backdrop.classList.add('opacity-0');
            box.classList.add('opacity-0', 'scale-95');
            setTimeout(() => {
                this.container.remove();
                this.container = null;
            }, 300);
        };

        this.container.querySelectorAll('.btn-close, .btn-close-main, .backdrop').forEach(el => el.onclick = close);

        // Animate In
        requestAnimationFrame(() => {
            this.container.querySelector('.backdrop').classList.remove('opacity-0');
            this.container.querySelector('.modal-box').classList.remove('opacity-0', 'scale-95');
        });
    }
}
